import { TimelineControllerSnapshot } from './types';
import { clampTime, frameToTime, normalizeRange } from './utils';

export class TimelineController {
  private snapshot: TimelineControllerSnapshot;

  constructor(duration = 0) {
    this.snapshot = {
      currentTime: 0,
      duration: Math.max(0, duration),
      playing: false,
      range: {
        startTime: null,
        endTime: null,
      },
    };
  }

  getSnapshot(): TimelineControllerSnapshot {
    return {
      ...this.snapshot,
      range: { ...this.snapshot.range },
    };
  }

  setDuration(duration: number) {
    this.snapshot.duration = Math.max(0, duration);
    this.snapshot.currentTime = clampTime(this.snapshot.currentTime, this.snapshot.duration);

    if (this.snapshot.range.startTime !== null && this.snapshot.range.endTime !== null) {
      this.snapshot.range = normalizeRange(
        this.snapshot.range.startTime,
        this.snapshot.range.endTime,
        this.snapshot.duration,
      );
    }
  }

  play() {
    this.clearRange();
    this.snapshot.playing = true;
  }

  pause() {
    this.snapshot.playing = false;
  }

  seek(time: number) {
    this.snapshot.currentTime = clampTime(time, this.snapshot.duration);
  }

  seekFrame(frame: number, fps: number) {
    this.seek(frameToTime(frame, fps));
  }

  clearRange() {
    this.snapshot.range = {
      startTime: null,
      endTime: null,
    };
  }

  playRange(startTime: number, endTime: number) {
    this.snapshot.range = normalizeRange(startTime, endTime, this.snapshot.duration);
    this.snapshot.currentTime = this.snapshot.range.startTime ?? 0;
    this.snapshot.playing = true;
  }

  update(delta: number): boolean {
    if (!this.snapshot.playing) return false;

    const safeDelta = Math.max(0, delta);
    const rangeEnd = this.snapshot.range.endTime ?? this.snapshot.duration;
    const nextTime = this.snapshot.currentTime + safeDelta;

    if (nextTime >= rangeEnd) {
      this.snapshot.currentTime = rangeEnd;
      this.snapshot.playing = false;
      return true;
    }

    this.snapshot.currentTime = nextTime;
    return false;
  }
}
